import type { ReactNode } from "react";
import { Column } from "@hightouch/htui";

type TableFrameProps = { children: ReactNode };

export const TableFrame = ({ children }: TableFrameProps) => (
  <Column
    borderWidth="hairline"
    borderStyle="solid"
    borderColor="base.border"
    borderRadius="md"
    overflow="hidden"
    bg="white"
  >
    {children}
  </Column>
);
